/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Cool_Otter_SlipInputs */

const en_quiet_cool_otter_slip = /** @type {(inputs: Quiet_Cool_Otter_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const de_quiet_cool_otter_slip = /** @type {(inputs: Quiet_Cool_Otter_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Quiet_Cool_Otter_SlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_cool_otter_slip = /** @type {((inputs?: Quiet_Cool_Otter_SlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Cool_Otter_SlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_cool_otter_slip(inputs)
	return de_quiet_cool_otter_slip(inputs)
});